import React, { Component, PropTypes } from 'react';
import { AuthStore } from 'stores';
import {
  Styles,
  Dialog,
  Paper,
  RaisedButton,
  CircularProgress
} from 'material-ui';
import RegisterForm from 'components/RegisterForm';
import { FormattedMessage } from 'react-intl';
const { Spacing } = Styles;
import * as SvgIcons from 'components/Material/SvgIcons';
import { InvitationActions } from 'actions';
import { history } from 'helpers';
import CountdownTimer from 'components/CountdownTimer';
import FullScreenDialog from 'components/FullScreenDialog';
import QuestionMark from 'Cio/Assets/QuestionMark';
import EmailGift from 'Cio/Assets/EmailGift';
import TooltipContainer from 'Cio/TooltipContainer';
import { Units, Colors } from 'Css';
import CoursioLogo from 'components/CoursioLogo';
import classNames from 'classnames';
import isDblTouchTap from 'Util/isDblTouchTap';
import cx from 'classnames';

const css = oxygenCss({
  message: {
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '26px',
    padding: Units.base,
    '@desktop': {
      padding: Units.keyline
    }
  },
  error: {
    color: Colors.material.red['500'].hex
  },
  root: {
    backgroundColor: '#FFFFFF',
    overflow: 'scroll',
    height: '100%',
    '@desktop': {
      display: 'flex',
      flexDirection: 'row'
    }
  },
  subHeader: {
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.3px',
    color: '#424242'
  },
  inputWrapper: {
    display: 'inline-flex',
    margin: 'auto',
    flexDirection: 'column',
    '@desktop': {
      flexDirection: 'row'
    }
  },
  needAccount: {
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'center',
    color: '#777',
    padding: Units.keyline
  },
  giftInput: {
    borderStyle: 'solid',
    borderColor: 'transparent',
    borderWidth: 1,
    borderRadius: 3,
    fontSize: 35,
    color: Colors.creen,
    // textAlign: 'center',
    width: 180,
    letterSpacing: '10px',
    lineHeight: '64px',
    margin: Units.base,
    padding: `0 ${Units.keyline / 2}px`,
    display: 'block',
    flexGrow: 1,
    backgroundColor: 'rgba(242, 242, 242, 0.32)',
    outline: 'none',
    ':active': {
      borderColor: Colors.creen,
      opacity: 1
    },
    ':focus': {
      borderColor: Colors.creen
    },
    '&hasText': {
      borderColor: Colors.creen
    },
    '::placeholder': {
      color: 'rgba(66, 66, 66, 0.07)'
    }
  },
  giftButton: {
    border: 'none',
    boxSizing: 'border-box',
    borderRadius: 5,
    backgroundColor: Colors.creen,
    fontSize: 16,
    minWidth: 165,
    lineHeight: '64px',
    margin: Units.base,
    padding: `0 48px`,
    display: 'block',
    flexGrow: 1,
    letterSpacing: '0.2px',
    color: 'rgba(255, 255, 255, 1)',
    outline: 'none',
    ':disabled': {
      color: 'rgba(255, 255, 255, 0.5)'
    }
  },
  left: {
    backgroundColor: Colors.creen,
    display: 'flex',
    flexDirection: 'column',
    padding: Units.base,
    boxSizing: 'border-box',
    '@desktop': {
      flexGrow: 1,
      flexShrink: 0,
      width: '50%'
    }
  },
  coursioLogo: {
    flexGrow: 0,
    flexShrink: 0,
    padding: Units.base * 2,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    '>SPAN': {
      color: '#FFFFFF',
      margin: `0 ${Units.base * 2}px`,
      fontSize: 14,
      letterSpacing: '0.3px'
    }
  },
  giftBanner: {
    flexGrow: 1,
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  },
  right: {
    boxSizing: 'border-box',
    '@desktop': {
      justifyContent: 'center',
      display: 'flex',
      flexGrow: 1,
      flexShrink: 0,
      width: '50%',
      alignItems: 'center',
      boxShadow: '0 1px 6px rgba(0,0,0,0.12), 0 1px 4px rgba(0,0,0,0.24)'
    },
    '>DIV': {
      textAlign: 'center'
    }
  },
  emailGift: {
    width: '100%',
    height: '100%'
  },
  giftWrapper: {
    width: 176,
    height: 176,
    padding: Units.keyline / 2,
    '@desktop': {
      width: 352,
      height: 352
    }
  },
  secret: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    borderRadius: 352 / 2,
    overflow: 'hidden',
    backgroundImage:
      'url(http://media3.giphy.com/media/3oEduTSu2ZgB4YHw9G/giphy.gif)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  }
});

const styles = {
  icon: {
    width: 32,
    height: 32,
    verticalAlign: 'middle'
  }
};

export default class AcceptGift extends Component {
  static propTypes = {
    accepted: PropTypes.bool,
    loggedIn: PropTypes.bool,
    expired: PropTypes.bool,
    giftCode: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func,
    muiTheme: PropTypes.object
  };

  state = {
    accepted: false,
    readyToAccept: false,
    secretActivated: false,
    giftCode: this.props.giftCode
  };

  componentDidMount() {
    if (this.input) {
      this.input.focus();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.owner && nextProps.owner) {
      this.setState({ readyToAccept: true });
    }
    if (!this.props.loggedIn && nextProps.loggedIn) {
      InvitationActions.acceptGift(this.state.giftCode);
    }
  }

  readyToAccept = () => {
    if (this.props.loggedIn) {
      InvitationActions.acceptGift(this.state.giftCode);
    } else {
      InvitationActions.checkGiftCode(this.state.giftCode);
    }
  };

  redirect = () => {
    history.push(`/dashboard`);
  };

  gotoLogin = () => {
    history.push(`/dashboard`);
  };

  handleSecretTouch = event => {
    if (isDblTouchTap(event)) {
      this.setState({ secretActivated: true });
    }
  };

  render() {
    const {
      expired,
      accepted,
      loggedIn,
      error,
      usedByMe,
      accepting,
      used
    } = this.props;
    const { giftCode, readyToAccept, secretActivated } = this.state;
    const { getIntlMessage } = this.context;
    let message = null;
    const empty = !giftCode || giftCode.length !== 6;
    if (expired) {
      message = getIntlMessage('gift.expired');
    } else if (usedByMe && accepted && used) {
      const color = Colors.material.green[500].hex;
      message = (
        <div>
          <SvgIcons.NavigationCheck
            color={color}
            style={{ verticalAlign: 'middle' }}
          />
          {getIntlMessage('gift.accepted')}
        </div>
      );
    } else if (used) {
      message = (
        <div>
          {getIntlMessage('gift.used')}
          {getIntlMessage('gift.help')}
        </div>
      );
    } else if (!accepting) {
      message = (
        <div>
          <div className={css.subHeader}>
            {getIntlMessage('gift.acceptSubText')}
          </div>
        </div>
      );
    }
    const tooltip = (
      <FormattedMessage
        message={getIntlMessage('aboutCoursio')}
        link={<a href='http://www.coursio.com'>coursio.com</a>}
      />
    );
    return (
      <div className={css.root}>
        <FullScreenDialog
          toolbar={false}
          open={readyToAccept && !loggedIn}
          padded
          onRequestClose={() => this.setState({ readyToAccept: false })}>
          <RegisterForm title={getIntlMessage('account.create')} />
        </FullScreenDialog>
        <div className={css.left}>
          <div className={css.coursioLogo} onTouchTap={() => this.gotoLogin()}>
            <CoursioLogo width={32} />
            <span>Sign in</span>
          </div>
          <div
            className={css.giftBanner}
            onTouchTap={this.handleSecretTouch}
            onDoubleClick={() => this.setState({ secretActivated: true })}>
            <div className={css.giftWrapper}>
              {secretActivated ? (
                <div className={css.secret} />
              ) : (
                <EmailGift className={css.emailGift} />
              )}
            </div>
          </div>
        </div>
        <div className={css.right}>
          <div>
            {message && (
              <div
                className={cx(
                  {
                    [css.error]: accepted && used && !usedByMe
                  },
                  css.message
                )}>
                {message}
              </div>
            )}
            {usedByMe && accepted && (
              <div style={{ textAlign: 'center' }}>
                {getIntlMessage('gift.redirectIncoming')}
                <br />
                <CountdownTimer
                  seconds={3}
                  color='#777'
                  alpha={0.3}
                  size={128}
                  onComplete={this.redirect}
                />
              </div>
            )}
            {accepting && (
              <div className={css.message}>
                <CircularProgress mode='indeterminate' />
              </div>
            )}
            <div className={css.inputWrapper}>
              <input
                ref={input => (this.input = input)}
                maxLength='6'
                placeholder={'T1E3L7'}
                className={classNames(css.giftInput, {
                  [css.hasText]: !empty
                })}
                value={giftCode}
                onChange={event =>
                  this.setState({ giftCode: event.target.value })
                }
              />
              <button
                disabled={readyToAccept || empty}
                className={css.giftButton}
                onTouchTap={this.readyToAccept}>
                {readyToAccept && !accepted ? (
                  <SvgIcons.NavigationCheck
                    color={'#FFF'}
                    style={styles.icon}
                  />
                ) : (
                  getIntlMessage('Continue')
                )}
              </button>
            </div>
            {error && (
              <div className={css.error}>
                {getIntlMessage('gift.doesNotExist')}
              </div>
            )}
            {!loggedIn && (
              <div className={css.needAccount}>
                {getIntlMessage('gift.needCoursioAccount')}
                {'  '}
                <TooltipContainer width={192} tooltip={tooltip}>
                  <QuestionMark />
                </TooltipContainer>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Gift/AcceptGift.js